<template>
  <onboarding-layout>
    <template #header>
      <h1>{{ $t('choosePlatform') }}</h1>
      <p>{{ $t('connectYourTradingAccount') }}</p>
    </template>

    <template #content>
      <div class="platforms-grid">
        <v-card v-for="platform in displayPlatforms" 
          :key="platform.platformName || platform.brokerName"
          class="platform-card"
          :class="{'selected-card': isSelected(platform)}"
          :elevation="0"
          @click="selectPlatform(platform)">
          <div class="card-content">
            <v-img
              :src="platform.type === 'MANUAL_IMPORT' ? require('@/assets/manual-import.svg') : platform.logoUrl"
              :alt="platform.platformName || platform.brokerName"
              contain
              height="100"
              max-width="130"
              class=""
            ></v-img>
            <p v-if="platform.type === 'MANUAL_IMPORT'" class="text-center mt-2">{{ platform.platformName }}</p>
          </div>
        </v-card>
      </div>
    </template>

    <template #actions>
      <v-btn
        color="primary"
        :disabled="!selectedPlatform"
        @click="continueToPlatformSetup"
      >
        {{ $t('continue') }}
      </v-btn>
    </template>
    <template #right-panel>
      <lottie :options="lottieOptions"/>
    </template>
  </onboarding-layout>
</template>

<script>
import * as animationData from '@/assets/animations/platforms.json';
import OnboardingLayout from '../components/OnboardingLayout.vue';
import LinkedPlatformRepository from '../../../repositories/linkedPlatform';

export default {
  name: 'Integrations',
  components: {
    OnboardingLayout,
  },
  data() {
    return {
      allPlatforms: {},
      lottieOptions: { animationData: animationData.default, loop: true },
      availablePlatforms: [],
      selectedPlatform: null,
      manualImportOption: {
        platformName: 'Manual Import',
        type: 'MANUAL_IMPORT'
      }
    }
  },
  async created() {
    await this.loadPlatforms();
  },
  computed: {
    displayPlatforms() {
      return [...this.availablePlatforms, /*this.manualImportOption*/];
    }
  },
  methods: {
    async loadPlatforms() {
      try {
        const response = await LinkedPlatformRepository.getAvailablePlatforms();
        this.allPlatforms = response.data;
        
        // Filter and combine platforms
        const apiPlatforms = this.allPlatforms.API_KEY || [];
        const passwordPlatforms = this.allPlatforms.PASSWORD || [];
        const pluginPlatforms = this.allPlatforms.PLUGIN || [];
        
        this.availablePlatforms = [
          ...apiPlatforms,
          ...passwordPlatforms,
          ...pluginPlatforms
        ];
      } catch (error) {
        //eslint-disable-next-line
        console.error('Error loading platforms:', error);
      }
    },
    selectPlatform(platform) {
      this.selectedPlatform = platform;
    },
    isSelected(platform) {
      return this.selectedPlatform === platform;
    },
    continueToPlatformSetup() {
      if (this.selectedPlatform) {
        this.$router.push({
          name: 'platform-setup',
          params: { 
            platform: JSON.stringify(this.selectedPlatform)
          }
        });
      }
    }
  }
}
</script>


<style lang="scss" scoped>
.platform-card {
  cursor: pointer;
  transition: all 0.2s ease;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 0;
  border: none;
  border-radius: 10px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.platform-card:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.selected-card {
  border: 2px solid var(--v-mainGreen-base) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.check-icon {
  position: absolute;
  top: 8px;
  right: 8px;
}

.back-link {
  cursor: pointer;
  color: #666666;
  font-size: 14px;
}

.back-link:hover {
  color: #333333;
}

.back-link {
  font-family: 'Avenir', sans-serif !important;
}

.v-application h1.text-h4,
.v-application h2,
.v-application p,
.v-application .v-btn,
.v-application .back-link {
  font-family: 'Avenir', sans-serif !important;
}

.content-indented {
  padding-left: 32px;
}

.split-layout {
  display: flex;
  min-height: 100vh;
}

.platforms-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.actions-container {
  text-align: left;
}

.platform-card {
  .card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    
    p {
      color: #666666;
      font-size: 14px;
      margin: 0;
    }
  }
}
</style>
